(function ($) {
  $(document).ready(function() {
    /**
     * COLLAPSES.
     * - Open the collapse when directly.
     */
    $('#publication-collapses a:not([data-toggle="collapse"])').on('click', function(e) {
      var $this = $(this);
          shortId = $this.attr('href').replace(/.*\.html#([\w\d]+)$/, '$1');
      if (shortId !== undefined) {
        $('#collapse-' + shortId).collapse('show');
      }
    });

    var anchor = window.location.hash.replace("#", "");
    $("#collapse-" + anchor).collapse();
  });
})(jQuery);
